var React = require('react');

function LastInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M285.6 273L90.79 467a24 24 0 0 1-33.88.1l-.1-.1-22.74-22.7a24 24 0 0 1 0-33.85L188.39 256 34.07 101.55A23.8 23.8 0 0 1 34 67.8l.11-.1L56.81 45a24 24 0 0 1 33.88-.1l.1.1L285.6 239a24.09 24.09 0 0 1 0 34z","className":"secondary","key":0}),React.createElement("path",{"d":"M478 273L283.19 467a24 24 0 0 1-33.87.1l-.1-.1-22.75-22.7a23.81 23.81 0 0 1-.1-33.75l.1-.1L380.8 256 226.47 101.55a24 24 0 0 1 0-33.85L249.22 45a24 24 0 0 1 33.87-.1.94.94 0 0 1 .1.1L478 239a24.09 24.09 0 0 1 0 34z","className":"primary","key":1})]);
}

LastInline.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = LastInline;

LastInline.default = LastInline;
